<style>
	.today-item{
		margin: 0;
		width: 23%;
		flex: 1;
		border-radius: 5px;
		color: #fff;
		padding: 5px 10px;
		margin-left: 0;
		background: rgb(90, 220, 156);
	}
	.total-data{
		    margin: 0;
		    padding: 0;
		    display: flex;
		    justify-content: space-between;
	}
	.el-row--flex {
	    display: flex;
	}
	.el-row {
	    box-sizing: border-box;
	}
	.total-info[data-v-4f6cddd5] {
	    background: #fff;
	    padding: 15px 15px
	}
	
	.total-info>p[data-v-4f6cddd5] {
	    margin-bottom: 15px
	}
	
	.total-info .total-data[data-v-4f6cddd5] {
	    display: flex;
	    justify-content: space-between
	}
	
	.total-info .total-data .today-item[data-v-4f6cddd5] {
	    width: 23%;
	    flex: 1;
	    margin-left: 15px;
	    border-radius: 5px;
	    color: #fff;
	    padding: 5px 10px
	}
	
	.total-info .total-data .today-item[data-v-4f6cddd5]:first-child {
	    margin-left: 0
	}
	
	.total-info .total-data .today-item p[data-v-4f6cddd5] {
	    font-size: 14px;
	    text-align: right;
	    line-height: 15px
	}
	
	.total-info .total-data .today-item p span[data-v-4f6cddd5] {
	    font-size: 24px;
	    margin-right: 5px
	}
	
	.total-info .total-data .today-item p[data-v-4f6cddd5]:first-child {
	    font-size: 16px;
	    border-bottom: 1px solid #fff;
	    text-align: left;
	    line-height: 30px
	}
	
	.total-info .total-data .today-item p:first-child .iconfont[data-v-4f6cddd5] {
	    font-size: 20px;
	    margin-right: 3px
	}
	
	.total-info .total-data .total-item[data-v-4f6cddd5] {
	    flex: 1;
	    margin-left: 15px
	}
	
	.total-info .total-data .total-item[data-v-4f6cddd5]:first-child {
	    margin-left: 0
	}
	
	.total-bar[data-v-4f6cddd5] {
	    background: #fff;
	    border-radius: 5px;
	    margin-top: 15px;
	    padding: 5px 15px;
	    position: relative
	}
	
	.total-bar .bar-time[data-v-4f6cddd5] {
	    position: absolute;
	    right: 15px;
	    top: 10px;
	    z-index: 5;
	    display: flex;
	    align-items: center
	}
	
	.total-line[data-v-4f6cddd5] {
	    background: #fff;
	    border-radius: 5px;
	    margin-top: 15px;
	    padding: 5px 15px
	}
	
	.line-filter[data-v-4f6cddd5] {
	    display: flex;
	    align-items: center;
	    border-bottom: 2px solid #e4e7ed;
	    padding: 5px;
	    justify-content: space-between
	}
	
	.admin-home[data-v-4bd05646] {
	    position: absolute;
	    display: flex;
	    font-family: bold;
	    width: 100%;
	    height: 100%;
	    align-items: center;
	    justify-content: center;
	    font-family: SimSun;
	    color: #333
	}

	        
</style>
<template>
  <!-- <el-row :gutter="40" class="panel-group">
	  
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col" v-for="item in statistics">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-people">
		  {{ item.title }}
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
           {{ item.num }}单
          </div>
		  <p class="card-panel-num">{{ item.money }}元</p>
        </div>
      </div>
    </el-col>
    
  </el-row> -->
  
  <div data-v-4f6cddd5="" class="admin-header" style="margin-bottom: 15px;">
  	<div data-v-4f6cddd5="" class="el-row el-row--flex">
  		<div data-v-4f6cddd5="" class="total-info el-col el-col-15" style="margin-right: 15px;">
  			<p data-v-4f6cddd5=""> 今日数据 <i data-v-4f6cddd5="" class="el-icon-refresh"></i>
  			</p>
  			<div data-v-4f6cddd5="" class="total-data">
  				<div data-v-4f6cddd5="" class="today-item" style="background: rgb(90, 220, 156);">
  					<p data-v-4f6cddd5="">
  						<i data-v-4f6cddd5="" class="iconfont icon-jiekou"></i>报价
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[0].num }}</span>单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[0].money }}</span>元
  					</p>
  				</div>
  				<div data-v-4f6cddd5="" class="today-item" style="background: rgb(114, 172, 236);">
  					<p data-v-4f6cddd5="">
  						<i data-v-4f6cddd5="" class="iconfont icon-yewu"></i>出单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[1].num }}</span>单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[1].money }}</span>元
  					</p>
  				</div>
  				<div data-v-4f6cddd5="" class="today-item" style="background: rgb(255, 121, 119);">
  					<p data-v-4f6cddd5="">
  						<i data-v-4f6cddd5="" class="iconfont icon-tuichu"></i>退单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[2].num }}</span>单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[2].money }}</span>元
  					</p>
  				</div>
  				<div data-v-4f6cddd5="" class="today-item" style="background: rgb(255, 211, 92);">
  					<p data-v-4f6cddd5="">
  						<i data-v-4f6cddd5="" class="iconfont icon-bianji1"></i>批单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[3].num }}</span>单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[3].money }}</span>元
  					</p>
  				</div>
  			</div>
  		</div>
  		<div data-v-4f6cddd5="" class="total-info el-col el-col-9">
  			<p data-v-4f6cddd5=""> 累计数据 <i data-v-4f6cddd5="" class="el-icon-refresh"></i>
  			</p>
  			<div data-v-4f6cddd5="" class="total-data">
  				<div data-v-4f6cddd5="" class="today-item total-item" style="background: rgb(114, 172, 236);">
  					<p data-v-4f6cddd5="">
  						<i data-v-4f6cddd5="" class="iconfont icon-yewu"></i>出单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[4].num }}</span>单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[4].money }}</span>元
  					</p>
  				</div>
  				<div data-v-4f6cddd5="" class="today-item total-item" style="background: rgb(255, 121, 119);">
  					<p data-v-4f6cddd5="">
  						<i data-v-4f6cddd5="" class="iconfont icon-tuichu"></i>退单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[5].num }}</span>单
  					</p>
  					<p data-v-4f6cddd5="">
  						<span data-v-4f6cddd5="">{{ statistics[5].money }}</span>元
  					</p>
  				</div>
  			</div>
  		</div>
  	</div>
  </div>
  
</template>

<script>
import CountTo from 'vue-count-to'

export default {
  data() {
	return {
		statistics: [{
			title: '报价',
			num: 10,
			money: '1024.2'
		}]
	}
  },
  components: {
    CountTo
  },
  created(){
	  this.getData();
  },
  methods: {
    handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type)
    },
	getData(){
		this.$api.post("/admin/census/getIndexCensus", {}).then((res) => {
			this.statistics = res.data;
		});
	}
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    // &:hover {
    //   .card-panel-icon-wrapper {
    //     color: #fff;
    //   }

    //   .icon-people {
    //     background: #40c9c6;
    //   }

    //   .icon-message {
    //     background: #36a3f7;
    //   }

    //   .icon-money {
    //     background: #f4516c;
    //   }

    //   .icon-shopping {
    //     background: #34bfa3
    //   }
    // }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3
    }

    .card-panel-icon-wrapper {
      float: left;
      // margin: 14px 0 0 14px;
      padding: 10px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
	  font-size: 20px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      //float: right;
      font-weight: bold;
      margin: 20px 6px 0 0;
      // margin-left: 0px;
	  text-align: right;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>